import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {TranslatePipe} from '@shared/pipes';

export interface PeriodHistoryStat {
	value: number | string;
	labelKey?: string;
	label?: string;
	unlimited?: boolean;
}

export interface PeriodHistoryItem {
	from: Date | string;
	to: Date | string;
	active: boolean;
	stats: PeriodHistoryStat[];
}

@Component({
	standalone: true,
	selector: 'green-period-history-carousel',
	imports: [CommonModule, DatePipe, TranslatePipe],
	templateUrl: './period-history-carousel.component.html',
	styleUrls: ['./period-history-carousel.component.scss'],
})
export class PeriodHistoryCarouselComponent implements OnChanges {
	@Input() periods: PeriodHistoryItem[] = [];
	@Input() initialIndex = 0;

	@Output() periodChange = new EventEmitter<{
		index: number;
		period: PeriodHistoryItem;
	}>();

	index = 0;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['periods'] || changes['initialIndex']) {
			const max = Math.max(0, (this.periods?.length ?? 1) - 1);
			this.index = Math.min(Math.max(this.initialIndex, 0), max);
		}
	}

	get current(): PeriodHistoryItem | null {
		return this.periods?.[this.index] ?? null;
	}

	get canPrev(): boolean {
		return this.index > 0;
	}

	get canNext(): boolean {
		return this.index < this.periods.length - 1;
	}

	prev(): void {
		if (this.canPrev) {
			this.index -= 1;
			this.emit();
		}
	}

	next(): void {
		if (this.canNext) {
			this.index += 1;
			this.emit();
		}
	}

	private emit(): void {
		if (this.current) {
			this.periodChange.emit({index: this.index, period: this.current});
		}
	}
}
